import { getPurchaseOrdersDetails, deletePurchaseDetails } from '@/services/suppliers.js'
import viewFrame from '@/components/viewFrame'
import history from '@/common/data/jsonData'
import { getHistoryList } from '@/services/resource'
import createTable from '@/components/createTable'
import customeTable from '@/components/customeTable'
import dialogEffect from '@/components/dialogEffect'
import jsonData from './jsonData'
import loading from '@/utils/loading.json'
import Utils from '@/utils/Utils.js'
import { mixin } from '@/mixins/viewDiolog.js'
import PurchaseForm from '@/views/suppliersManager/purchase/add/index.vue'

export default {
  components: {
    createTable,
    viewFrame,
    customeTable,
    dialogEffect,
    PurchaseForm
  },
  mixins: [mixin],
  data () {
    return {
      urlParams: null,
      validateVisible: false,
      buttonObj: [],
      titleObject: {
        show: true
      },
      custName: {},
      formData: {},
      modifyData: {},
      type: '',
      basicViewItem: jsonData.basicViewItem,
      historyTableItem: history.historyTableItem,
      dialogData: [],
      batchData: [],
      dialogVisible: false,
      historyTableData: []
    }
  },
  created () {
    const _this = this
    _this.urlParams = _this.$route.params
  },
  mounted () {
    const _this = this
    _this.init()
  },
  methods: {
    setGlobalLoading (show) {
      const _this = this
      show ? _this.$store.state.app.loading = _this.$loading(loading) : _this.$store.state.app.loading.close()
    },
    // 初始化
    init () {
      const _this = this
      Object.assign(this.titleObject, { title: `${_this.$t('form.purchase.purchaseOrder')} No. `, data: _this.urlParams.id })
      _this.setGlobalLoading(true)
      getPurchaseOrdersDetails(_this.urlParams.id).then(res => {
        _this.setGlobalLoading(false)
        _this.$message({
          type: 'success',
          message: _this.$t('message.loadSuccess')
        })
        this.$set(this, 'custName', res.data.purchase_order)
        Object.assign(this.titleObject, { title: `${_this.$t('form.purchase.purchaseOrder')} No. `, data: res.data.purchase_order.basic_information.order_no.value })
      })
      //  获取历史操作
      getHistoryList({ item_type: 'PurchaseOrder', item_id: _this.urlParams.id }).then(res => {
        if (res.status === 200) {
          this.historyTableData = res.data.versions
        }
      })
    },
    handleBasicInfoForwardToPage (data, name) {
      if (name === 'supplier') {
        this.$router.push({
          name: 'suppliersDetail',
          params: {
            id: data.id
          }
        })
      }
    },
    async handleClick (type, data) {
      console.log(type, data)
      if (type === 'create') {
        this.$router.push({
          name: 'purchaseAdd'
        })
      }
      if (type?.action === 'create') {
        this.$router.push({
          name: 'purchaseAdd'
        })
      }
      if (type?.action === 'edit') {
        this.$router.push({
          name: 'purchaseEdit',
          params: {
            id: this.urlParams.id
          }
        })
      }
      if (type?.action === 'destroy') {
        this.deleteClick(this.urlParams.id, deletePurchaseDetails, 'suppliersManagerList')
      }
    },
    handleCusClick (item) {
      Utils.custOperate(item, this)
    }
  }
}
